import React from 'react';

const JSON_Server = () => {
  return (
    <div >
      <h1>JSON_Server</h1>
      <p>Placeholder component for: "JSON Server"</p>
    </div>
  );
};

export default JSON_Server;
